import axios from 'axios';
import API from '../config/api';
import {resHandle, getAxiosErrorMessage} from '../helper';


export const userListService = params => axios.get(API.USER_LIST + params).then(res => {
    let {status, data} = resHandle(res);
    return {status, data};
}).catch(error => ({
    status: false,
    data: getAxiosErrorMessage(error, 'Unable to load users'),
}));

export const createUserService = params => axios.post(API.CREATE_USER, params, { timeout: 120000 })
    .then(res => {
        let {status, data} = resHandle(res);
        return {status, data};
    })
    .catch(error => ({
        status: false,
        data: getAxiosErrorMessage(error, 'Unable to create user'),
    }));

export const userAccountService = params =>

    axios.get(API.USER_ACCOUNT + params).then(res => {

        console.log(res,"ssssssssssss")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });

export const userGetCurrencyService = params =>

    axios.get(API.GET_CURRENCY + params).then(res => {

        let {status, data} = resHandle(res);

        return {status, data};
    });


export const userProfileUpdate = params =>

    axios.put(API.USER_ACCOUNT_UPDATE , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });

export const createStripeCustomer = params =>

    axios.post(API.CREATE_CUSTOMER , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });

export const updateUserCredit = params =>

    axios.post(API.UPDATE_CREDIT , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });
export const updateThresholdCredit = params =>

    axios.post(API.UPDATE_THRESHOLd_CREDIT , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });

    export const updateShowCredit = (params) => {
        return axios.post(API.UPDATE_SHOW_CREDIT, params).then(res => {
            let { status, data } = resHandle(res);
            return { status, data };
        });
    };

export const updateSubscriptionApi = params =>

    axios.post(API.UPDATE_SUBSCRIPTION  , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });

export const createSubscription = params =>

    axios.post(API.CREATE_SUBSCRIPTION , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });
export const cancelSubscriptionApi = params =>

    axios.post(API.CANCEL_SUBSCRIPTION , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });
export const createCharge = params =>

    axios.post(API.CREATE_CHARGE , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")
if(status==0){
    return res

}else {
    return {status, data};

}
    });
export const createChargeByAuthenticatedCard = params =>

    axios.post(API.CREATE_CHARGE_3D , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return res;
    });

export const updatePackCredit = params =>

    axios.post(API.UPDATE_USER_PACK_CREDIT, params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });

export const getUserStripePrices = params =>

    axios.get(API.GET_STRIPE_PRICE + params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });

export const getCreditsListApi = params =>

    axios.get(API.GET_CREDIT_PACK + params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });



export const getCard = params =>

    axios.post(API.GET_CARD , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });

export const getUserInvoices = params =>

    axios.get(API.GET_INVOICES + params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });
export const getUserChargesBill = params =>

    axios.get(API.GET_CHARGE_BILL + params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });




export const uploadBackground = (obj, params) =>

    axios.post(API.UPLOAD_BG+obj , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });


export const setBackground = params =>

    axios.post(API.SET_BG , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });

export const updateShowActiveLogo = params =>

    axios.post(API.UPDATE_ACTIVE_LOGO , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });


export const deleteBackground = params =>

    axios.post(API.DEL_BG , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });

export const userDeleteAccount = params =>

    axios.post(API.DEL_ACCOUNT + params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });



export const addCard = params =>

    axios.post(API.ADD_CARD , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });



export const updateStripeCard = params =>

    axios.post(API.UPDATE_CARD , params).then(res => {

        console.log(res,"ssssssssssssOBJJJJJJJ")
        let {status, data} = resHandle(res);
        console.log(status,"statusstatusstatus", data,"status, datassssssssssss")

        return {status, data};
    });

export const getInvoiceHistory = params =>
    axios.get(API.ADMIN_INVOICE_HISTORY + params).then(res => {
        let {status, data} = resHandle(res);
        return {status, data};
    });

    
